import { render, staticRenderFns } from "./TableLiveListTournaments.vue?vue&type=template&id=5f09f730"
import script from "./TableLiveListTournaments.js?vue&type=script&lang=js&external"
export * from "./TableLiveListTournaments.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports